import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import apihost from "../../services/apihostname";

//Import module Modal
import Modal from "react-bootstrap/Modal";

// Import module Services
import factoryService from "../../services/factory.service";
import TambonService from "../../services/tambon.service";
// import authService from "../../services/auth.service";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import loading
import LoadingAlert from "../../components/LoadingAlert";

//Import farmer.css
import "./factory.css";

function ModalEditFactory(props) {
  const [loadAlert, setLoadAlert] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  // const [factory, setFactory] = useState([]);
  // const [data, setData] = useState([]);
  // const [ocsb, setOcsb] = useState([]);
  // const [factory, setFactory] = useState([]);
  // const [region, setRegion] = useState([]);
  const [prov, setProv] = useState([]);
  const [amp, setAmp] = useState([]);
  const [tam, setTam] = useState([]);

  const handleClose = () => {
    initialForm();
    setErrors({});
    props.hidden(false);
  };

  const getProv = () => {
    return Promise.resolve(
      TambonService.get({ pro_id: "0", amp_id: "0", tam_id: "0" })
        .then((response) => {
          setProv(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching Prove: ", error);
        })
    );
  };

  useEffect(() => {
    getProv();
    if (props.data.factoryId) {
      factoryService
        .getFactoryById(props.data.factoryId)
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            console.log(res.data.data);
            let cwt = 0;
            let amp = 0;
            let tam = 0;
            TambonService.getByname({
              prov_name: res.data.data.prov_namt,
              amp_name: res.data.data.amp_namt,
              tam_name: res.data.data.tam_namt,
            }).then((response) => {
              console.log(response.data.data);
              cwt = response.data.data.cwt;
              amp = response.data.data.amp;
              tam = response.data.data.tambon;
              setAmp([
                {
                  value: response.data.data.amp,
                  label: response.data.data.amp_namt,
                },
              ]);
              setTam([
                {
                  value: response.data.data.tambon,
                  label: response.data.data.tam_namt,
                },
              ]);
              setForm({
                factoryId: res.data.data.factory_id,
                factoryCode: res.data.data.factory_code,
                factoryAddress: res.data.data.factory_address,
                factoryFax: res.data.data.factory_fax,
                factoryNameTh: res.data.data.factory_name_th,
                factoryNameEn: res.data.data.factory_name_en,
                factoryPhone: res.data.data.factory_phone,
                factoryRegion: res.data.data.region_code,
                factoryStatus: res.data.data.status_active,
                factoryProvince: cwt,
                factoryProvName: cwt.label,
                factoryDistrict: amp,
                factoryDistName: amp.label,
                factorySubdistrict: tam,
                factorySubdistName: tam.label,
              });
              setLoadAlert(false);
              console.log(form);
            });
          } else {
            alert(res.data.message);
          }
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setErrors(error);
        });
    }
    // }
  }, [props.data.factoryId]);

  const getAmp = (prov) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching amp: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getAmp(form.factoryProvince);
  // }, [form.factoryProvince]);

  const handleProvChange = async (prov) => {
    setErrors({
      ...errors,
      factoryProvince: null,
    });
    if (prov && prov != "") {
      await getAmp(prov).then((response) => {
        setAmp(response.data.data);
        setForm({
          ...form,
          factoryProvince: prov,
          factoryDistrict: "",
          factorySubdistrict: "",
        });
      });
    } else {
      setAmp([]);
      setTam([]);
      setForm({
        ...form,
        factoryDistrict: "",
        factorySubdistrict: "",
      });
    }
  };

  const getTam = (prov, amp) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: amp ? amp : 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching tam: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getTam(form.factoryProvince, form.factoryDistrict);
  // }, [form.factoryDistrict]);

  const handleAmpChange = async (prov, amp) => {
    setErrors({
      ...errors,
      factoryDistrict: null,
    });
    if (amp && amp != "") {
      await getTam(prov, amp).then((response) => {
        setTam(response.data.data);
        setForm({
          ...form,
          factoryDistrict: amp,
          factorySubdistrict: "",
        });
      });
    } else {
      setTam([]);
      setForm({
        ...form,
        factorySubdistrict: "",
      });
    }
  };

  const initialForm = () => {
    // setForm({});
    setErrors({});
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field.name]: value,
    });

    if (errors[field.name])
      setErrors({
        ...errors,
        [field.name]: null,
      });
  };

  const findFormErrors = () => {
    // const { factoryCode, factoryName, factoryFax } = form;
    const newErrors = {};

    // // factoryCode errors
    // if (!factoryCode || factoryCode === "") newErrors.factoryCode = "กรุณากรอก Code";

    // // factoryName errors
    // if (!factoryName || factoryName === "") newErrors.factoryName = "กรุณากรอก name";
    // else if (factoryName.length < 6)
    //   newErrors.factoryName = "name ต้องมากกว่า 5 ตัว";

    // // factoryFax errors
    // if (!factoryFax || factoryFax === "") newErrors.factoryFax = "กรุณากรอก factoryFax";
    // else if (factoryFax.length < 6)
    //   newErrors.factoryFax = "factoryFax ต้องมากกว่า 6 ตัวอักษร";

    // factoryAddress errors
    // if (!factoryAddress || factoryAddress === "")
    //   newErrors.factoryAddress = "กรุณากรอกยืนยัน Password";
    // else if (factoryAddress != factoryFax)
    //   newErrors.factoryAddress = "ยืนยัน Password ไม่ถูกต้อง";

    // // comment errors
    // if (!comment || comment === "") newErrors.comment = "cannot be blank!";
    // else if (comment.length > 100) newErrors.comment = "comment is too long!";

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      alert(newErrors);
      setErrors(newErrors);
    } else {
      console.log(props.data);
      factoryService
        .updateFactory(form)
        .then((response) => {
          console.log(response);
          if (response.data.success) {
            console.log(response.data.factory.factoryId);
            // console.log(response.data.factory.dat
            var newArray = props.factorydata.map(function (el) {
              if (el.factoryId != response.data.factory.factoryId) {
                return el;
              } else {
                var check = response.data.factory;
                return check;
              }
            });
            props.setdata([...newArray]);
            alert("ปรับปรุงข้อมูลเรียบร้อย !");
          } else {
            alert(response.data.message);
          }
        })
        .catch((error) => {
          alert(error);
          console.log(error);
        })
        .finally(() => {
          console.log(false);
          props.hidden(false);
          setLoadAlert(false);
        });
    }
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขข้อมูลโรงงาน</Modal.Title>
        </Modal.Header>
        {loadAlert ? <LoadingAlert /> : ""}
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="3">
                <Form.Group className="mb-2">
                  <Form.Label>สถานะ</Form.Label>
                  <Form.Select
                    name="factoryStatus"
                    value={form.factoryStatus}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryStatus}
                  >
                    <option value="1">ใช้งาน</option>
                    <option value="0">ยกเลิก</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryStatus}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="9">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อโรงงาน (ไทย)</Form.Label>
                  <FormControl
                    placeholder="ชื่อโรงงาน"
                    name="factoryNameTh"
                    value={form.factoryNameTh}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryNameTh}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryNameTh}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="9">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อโรงงาน (อังกฤษ)</Form.Label>
                  <FormControl
                    placeholder="ชื่อโรงงาน"
                    name="factoryNameEn"
                    value={form.factoryNameEn}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryNameEn}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryNameEn}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group className="mb-2">
                  <Form.Label>รหัสโรงงาน</Form.Label>
                  <FormControl
                    placeholder="รหัสโรงงาน"
                    type="text"
                    name="factoryCode"
                    value={form.factoryCode}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryCode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ภูมิภาค</Form.Label>
                  <Form.Select
                    name="factoryRegion"
                    value={form.factoryRegion}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryRegion}
                  >
                    <option value="">เลือกภูมิภาค</option>
                    <option value="1">กลาง</option>
                    <option value="2">เหนือ</option>
                    <option value="3">ตะวันออกเฉียงเหนือ</option>
                    <option value="4">ตะวันออก</option>
                    <option value="5">ใต้</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryRegion}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>จังหวัด</Form.Label>
                  <Form.Select
                    name="factoryProvince"
                    value={form.factoryProvince}
                    onChange={(e) => handleProvChange(e.target.value)}
                    isInvalid={!!errors.factoryProvince}
                  >
                    <option value="">เลือกจังหวัด</option>
                    {prov.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryProvince}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อำเภอ</Form.Label>
                  <Form.Select
                    name="factoryDistrict"
                    value={form.factoryDistrict || ""}
                    onChange={(e) =>
                      handleAmpChange(form.factoryProvince, e.target.value)
                    }
                    isInvalid={!!errors.factoryDistrict}
                  >
                    <option value="">เลือกอำเภอ</option>
                    {amp.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryDistrict}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำบล</Form.Label>
                  <Form.Select
                    name="factorySubdistrict"
                    value={form.factorySubdistrict || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factorySubdistrict}
                  >
                    <option value="">เลือกตำบล</option>
                    {tam.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factorySubdistrict}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="12">
                <Form.Group className="mb-2">
                  <Form.Label>เลขที่</Form.Label>
                  <FormControl
                    placeholder="เลขที่"
                    type="text"
                    name="factoryAddress"
                    value={form.factoryAddress}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryAddress}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryAddress}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โทรศัพท์</Form.Label>
                  <FormControl
                    placeholder="โทรศัพท์"
                    name="factoryPhone"
                    value={form.factoryPhone}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryPhone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryPhone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>แฟ็กซ์</Form.Label>
                  <FormControl
                    placeholder="แฟ็กซ์"
                    name="factoryFax"
                    type="text"
                    value={form.factoryFax}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryFax}
                  />{" "}
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryFax}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {/* <Button variant="primary" type="submit">
            ตกลง
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              props.closeForm();
              initialForm();
            }}
          >
            ยกเลิก
          </Button> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            ตกลง
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalEditFactory;

ModalEditFactory.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.object,
  setdata: PropTypes.func,
  factorydata: PropTypes.array,
  // factory_id: PropTypes.number,
};
ModalEditFactory.defaultProps = {
  data: {},
};
